// @ts-nocheck

import { use, useEffect, useState } from "react";
import { db } from "../../db/db";
import { useLiveQuery } from "dexie-react-hooks";

import { API_BASE_URL as publicApiUrl } from "../../utils/api";

function HolidaySend({ id }) {
  const holidays = useLiveQuery(async () => {
    return await db.holiday_requests
      .where("postedSuccessfully")
      .equals(0)
      .toArray();
  });
  useEffect(() => {
    if (holidays) {
      if (holidays?.length > 0) {
        holidays.map((holiday) => {
          const bodyRaw = holiday;
          bodyRaw.t = "spcholiday";
          bodyRaw.c = "ltgb2qzc31qn88xor";
          bodyRaw.save_new_record = "true";
          const body = new URLSearchParams(bodyRaw).toString();
          fetch(`${publicApiUrl}/holiday`, {
            body: body,
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          })
            .then((res) => res.json())
            .then(() => {
              db.holiday_requests
                .update(holiday["id"], {
                  postedSuccessfully: 1,
                })
                .catch((error) => {
                  console.log(error);
                });
            });
        });
      }
    }
  }, [holidays]);

  return <></>;
}

export default HolidaySend;
